import axios from "axios";
import { DOCUMENT_STATUS, DOCUMENT_TYPE, UTILS } from "../../endpointsConst";

const DocumentDropdowns = {};

DocumentDropdowns.getDocumentStatuses = (lang) =>
    axios.get(UTILS + DOCUMENT_STATUS + `?lang=${lang}`).catch((e) => {
        console.log(e);
    });

DocumentDropdowns.getDocumentTypes = (lang) =>
    axios.get(UTILS + DOCUMENT_TYPE + `?lang=${lang}`).catch((e) => {
        console.log(e);
    });

export { DocumentDropdowns };
